module.exports = __webpack_public_path__ + "yubico_70x70.7f1bfceac388df5ddb85b4cc34219266.png";